export const AC_TYPES = {
  normal: 'normal',
  time: 'time',
  score: 'score',
};

export const AC_UNITS = {
  currency: 'currency',
};

export const AC_GROUPS = {
  valuation: 'Valuation ratios',
  dividend: 'Dividend',
  shareRelated: 'Market Cap / Shares',
  profitabilityRatio: 'Profitability ratios',
  // perShareRatios: 'Per Share Ratios',
  managementEffectiveness: 'Management effectiveness',
  financialStrength: 'Financial strength',
  efficiencyRatios: 'Efficiency ratios',
  growthRates: 'Growth rates',
  consensusEstimates: 'Consensus estimates',
  companyScore: 'Company score',
  macroSensitivity: 'Macrosensitivity',
  pricePerformance: 'Price performance',
  volume: 'Volume',
  technicalIndicatorTrend: 'Technical indicators (Trend)',
  technicalIndicatorOscillator: 'Technical indicators (Oscillator)',
};
